// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmUserRepoManager from "../../../../../library/data-source/crm-user/repo/CrmUserRepoManager.bs.js";
import * as LoadAssistInfoRepoManager from "./repo/load-assist-info/LoadAssistInfoRepoManager.bs.js";
import * as TicketingOrderRepoManager from "./repo/order/TicketingOrderRepoManager.bs.js";

function fetchOrder(order_id, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return Curry._2(RepoInstance.fetchOrder, order_id, country);
}

function fetchOrderScheduleStatus(order_id, country, onSuccessCb, onErrorCb) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchOrderSchedule, order_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchOrderFares(order_id, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return Curry._2(RepoInstance.fetchOrderFare, order_id, country);
}

function fetchOrderComments(order_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchOrderComments, order_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchTicketsForOrder(order_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchOrderTickets, order_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function createOrderComments(params, onSuccessCb, onErrorCb, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createOrderComments, params, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchCurrentUserDetails(country) {
  var RepoInstance = CrmUserRepoManager.getCrmUserRepo(undefined);
  return Curry._1(RepoInstance.fetchCurrentUser, country);
}

function fetchPartnerEarnings(order_crn, onSuccessCb, onErrorCb, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchPartnerEarnings, order_crn, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function createPartnerGoodwillDiscount(payload, onSuccessCb, onErrorCb, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createPartnerGoodwillDiscount, payload, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchLoadAssistInfo(order_crn, onSuccessCb, onErrorCb, country) {
  var RepoInstance = LoadAssistInfoRepoManager.getLoadAssistInfoRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchLoadAssistInfo, order_crn, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

export {
  fetchOrder ,
  fetchOrderScheduleStatus ,
  fetchOrderFares ,
  fetchOrderComments ,
  fetchTicketsForOrder ,
  createOrderComments ,
  fetchCurrentUserDetails ,
  fetchPartnerEarnings ,
  createPartnerGoodwillDiscount ,
  fetchLoadAssistInfo ,
  
}
/* CrmUserRepoManager Not a pure module */
